import { Button, Divider } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { AdminTransfer } from 'src/core/models'
import { DepositsDetailsModal } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { adminTransfersSelector, validateAdminTransferSelector } from 'src/features'
import { CloseOutlined } from '@ant-design/icons'
import styles from '../../TransferValidateButton/TransferValidateButton.module.scss'
import { rejectBankTransfer } from 'src/features/admin/actions'


const TransferRejectButton: React.FC<{ transfer: AdminTransfer }> = ({ transfer }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const transfers = useAppSelector(adminTransfersSelector)

  const dispatch = useAppDispatch()

  const { loading, currentTransfer } = useAppSelector(validateAdminTransferSelector)
  const isLoading = loading && transfer.order.id === currentTransfer

  const handleTransferReject = () => {
    dispatch(rejectBankTransfer(transfer.order.id, transfers.data))
    if (isLoading === true) {
      setIsModalVisible(false)
    }
  }

  return <>
    <Button
      type='dashed'
      size='middle'
      loading={isLoading}
      disabled={isLoading}
      icon={<CloseOutlined />}
      className={styles.button}
      onClick={() => setIsModalVisible(true)}
    >{isLoading ? t('Transfer.Rejecting') : t('Transfer.Reject')}
    </Button>

    <DepositsDetailsModal
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
      modalTitle={t('Transfer.RejectModalTitle')}
      deposit={{
        currency_token_id: transfer.order.currency_token,
        amount: transfer.order.total,
        internal_reference: transfer.order.reference
      }}
      footerContent={<div className='mt-4'>
        <Divider />
        <Button
          danger
          block
          size='large'
          loading={isLoading}
          disabled={isLoading}
          className='radius-100'
          onClick={() => handleTransferReject()}
        >{t('Transfer.Reject')}
        </Button>
      </div>}
    />
  </>
}

export default TransferRejectButton
